<template>
  <div>
    &nbsp;
    <b-input-group>
      <b-button v-b-modal.modalAddPallets variant="primary"
        >Agregar Manualmente</b-button
      >
      &nbsp;&nbsp;&nbsp;
      <b-button
        @click="$event.target.blur()"
        :pressed.sync="buttonBarcodeScanner"
        :variant="variantBarcodeScanner"
      >
        {{ textBarcodeScanner }}
      </b-button>
      &nbsp;&nbsp;&nbsp;
      <b-form-input
        type="text"
        v-model="dispatch_weight"
        v-on:keyup="inputSoloNumeroDecimal"
        placeholder="Peso Bruto Pallet"
      />
    </b-input-group>
    <br /><br />
    <!-- Modal Component -->
    <b-modal
      id="modalAddPallets"
      :title="titleModolaAddGuia"
      size="xl"
      class="modal-primary"
      hide-footer
    >
      <div id="stock">
        <v-server-table
          :url="url"
          ref="table"
          :columns="columns"
          s
          :options="options"
          :theme="theme"
          id="dataTable"
        >
          <div slot="net_kilograms" slot-scope="props">
            <div style="text-align: right">
              {{ props.row.net_kilograms.format("0,0.00") }}
            </div>
          </div>
          <div slot="quantity" slot-scope="props">
            <div style="text-align: right">{{ props.row.quantity }}</div>
          </div>
          <div slot="waybill_number" slot-scope="props">
            <div style="text-align: right">{{ props.row.waybill_number }}</div>
          </div>
          <div slot="pallet_number" slot-scope="props">
            <a
              href="#"
              @click.prevent="addPalletGuia(props.row)"
              class="text-primary"
              ><i class="fa fa-lg fa-plus mt-1"></i
            ></a>
            &nbsp;
            {{ props.row.pallet_number }}
          </div>
        </v-server-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";

window.axios = require("axios");

import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import { mapState, mapActions, mapGetters } from "vuex";

numeral.locale("es");

Vue.use(ServerTable);

export default {
  name: "AddPallet",
  components: {
    ServerTable
  },
  created() {},
  props: [
    "waybill_id",
    "waybill_numero",
    "tableDataPalletStock",
    "kilosBrutosTotales",
    "client_customer"
  ],
  data() {
    return {
      titleModolaAddGuia: "Pallets en Stock",
      buttonBarcodeScanner: false,
      variantBarcodeScanner: "danger",
      textBarcodeScanner: "Activar Barcode",
      dispatch_weight: "",

      product: "",
      selected: {
        product_type: "",
        container: {
          id: ""
        }
      },
      selectOptions: {
        products: [],
        product_types: [],
        containers: []
      },
      theme: "bootstrap4",
      template: "default",
      columns: [
        "pallet_number",
        "product_name",
        "product_type_name",
        "condition",
        "variety_name",
        "origin_name",
        "container_code",
        "container_name",
        "string_specs",
        "quantity",
        "waybill_number",
        "net_kilograms"
      ],
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(
              results[key].waybill_date
            ).format("DD-MM-YYYY");
            results[key].net_kilograms = numeral(
              parseFloat(results[key].net_kilograms)
            );
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        filterByColumn: true,
        filterable: [
          "client_customer_name",
          "pallet_number",
          "lot_number",
          "product_type_name",
          "condition",
          "variety_name",
          "product_name",
          "container_code",
          "container_name",
          "quantity",
          "origin_name",
          "waybill_number"
        ],
        headings: {
          pallet_number: "Número",
          product_name: "Producto",
          product_type_name: "Tipo",
          condition: "Condición",
          variety_name: "Variedad",
          origin_name: "Origen",
          container_name: "Formato/Recip",
          container_code: "Código",
          quantity: "Cantidad",
          waybill_number: "Guia",
          net_kilograms: "Kg Neto",
          string_specs: "Specs"
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Buscar",
          filterPlaceholder: "",
          count: "",
          limit: ""
        },
        perPage: 10,
        debounce: 800,
        columnsDropdown: true,
        columnsDisplay: {
          document: "not_desktop",
          product_name: "not_desktop",
          waybill_number: "not_desktop",
          product_type_name: "min_desktop",
          string_specs: "min_desktop",
          daystay: "not_desktop",
          condition: "min_desktop",
          lot_number: "min_desktop"
        }

        // columnsDropdown: true,
        //filterByColumn: true,
      }
    };
  },
  methods: {
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.selectOptions.products = products;
        })
        .catch((error) => console.log(error));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.selectOptions.product_types = res.data.product_types;
          this.selectOptions.containers = res.data.containers;
        })
        .catch((error) => console.log(error));
    },
    loadTable: function () {
      this.$axios
        .get("/api/v1/allstock/get_pallets_stock_all/")
        .then((res) => {
          const data = res.data;
        })
        .catch((error) => console.log(errors));
    },
    addPalletGuia: function (row) {
      var padre = this;
      const Data = {
        waybillId: this.waybill_id,
        numero_pallet: row.pallet_number,
        client_customer: this.client_customer.id,
        client_customer_text: this.client_customer.text,
        dispatch_weight: this.dispatch_weight != "" ? this.dispatch_weight : 0
      };
      this.$axios
        .put("/api/v1/allstock/dispatch_pallet/", Data)
        .then((res) => {
          if (res.data.status == 0) {
            miniToastr.error(res.data.message, "");
          }

          if (res.data.status == 1) {
            this.$refs.table.refresh();
            this.$emit("addPalletswaybill");
            miniToastr.success(res.data.message, "");
          }

          if (res.data.status == 2) {
            miniToastr.warn(res.data.message);
          }

          if (res.data.status == 3) {
            miniToastr.warn(res.data.message);
          }
        })
        .catch((error) => console.log(error));
    },
    onBarcodeScanned(barcode) {
      var vm = this;
      const Data = {
        waybillId: this.waybill_id,
        numero_pallet: barcode,
        client_customer: this.client_customer.id,
        client_customer_text: this.client_customer.text,
        dispatch_weight: this.dispatch_weight != "" ? this.dispatch_weight : 0
      };
      this.$axios
        .put("/api/v1/allstock/dispatch_pallet/", Data)
        .then((res) => {
          if (res.data.status == 0) {
            miniToastr.error(res.data.message, "");
          }

          if (res.data.status == 1) {
            this.$emit("addPalletswaybill");
            miniToastr.success(res.data.message, "");
          }

          if (res.data.status == 2) {
            miniToastr.warn(res.data.message);
          }

          if (res.data.status == 3) {
            miniToastr.warn(res.data.message);
          }

          this.inputCodePallet = "";
          this.$refs.search.focus();
        })
        .catch((error) => console.log(error));

      console.log(barcode);
      this.$nextTick(() => {
        // this.$refs['barcodemodal'].show()
      });
    },
    inputSoloNumeroDecimal(event) {
      var piecesArray = event.target.value.split(".");

      if (piecesArray.length > 2) {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^0-9.]/, "");
      }
    }
  },
  mounted() {
    this.loadTable();
    this.getProducts();
  },
  computed: {
    url() {
      return (
        "/api/v1/stock/?" +
        "client_customer=" +
        this.client_customer.id +
        "&variety__product=" +
        this.product +
        "&product_type=" +
        this.selected.product_type +
        "&container=" +
        this.selected.container.id
      );
    },
    ...mapGetters("socketModule", ["selectedScale"]),
    ...mapState("socketModule", ["socketWeight", "connected"])
  },
  watch: {
    product: {
      handler(val) {
        this.getProductSet(this.product);
        this.selected.product_type = "";
        this.selected.container.id = "";
      },
      deep: true
    },
    buttonBarcodeScanner(value) {
      if (value) {
        this.$barcodeScanner.init(this.onBarcodeScanned);
        this.variantBarcodeScanner = "success";
        this.textBarcodeScanner = "Barcode Activo";
      } else {
        // Remove listener when component is destroyed
        this.$barcodeScanner.destroy();
        this.variantBarcodeScanner = "danger";
        this.textBarcodeScanner = "Activar Barcode";
      }
    },
    socketWeight(newValue, oldValue) {
      this.dispatch_weight = newValue;
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__columns-dropdown {
    padding-right: 20px;
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
